<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EaX5ZG/tc-custom/9781908117588.jpg?1726871266150" alt="This image is the cover for the book Tally Ho!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tally Ho!
      </h1>
      <p class="bookDescription body article font2">
        <b>A memoir of the life and World War II service of Battle of Britain veteran, RAF fighter pilot Bob Foster.</b><br/><br/> Bob Foster's flying years began shortly before WWII, when he learned to fly with the RAFVR. Called up for war service in September 1939, he completed his training and was posted to 605 Squadron, equipped with Hawker Hurricanes. By early September 1940 he and his Squadron were in the thick of the air fighting over southern England, operating from Croydon.<br/><br/> Surviving the Battle, he later became an instructor, but shortly after joining 54 Squadron, which had Spitfires, he and his unit were sent to Australia to defend the Darwin area from Japanese incursions. Awarded the DFC for his efforts, he returned to the UK and was given an assignment with a RAF public relations outfit, ending up in Normandy within three weeks of the invasion of 1944.<br/><br/> Often serving right up in the front lines, Bob<br/><br/> saw the war at very close hand, and then quite by chance became one of the first, if not the first, RAF officer to enter Paris with the liberating French army, and again, by chance, was in General de Gaulle's triumphant procession down the Champs-Élysées.<br/><br/> His memoir is an entertaining collection of stories and reminiscences of two distinct areas of WWII, which also shows how luck often shaped the lives of the fighter pilots involved. Bob Foster later became a successful sales manager with Shell-Mex and BP, as well as serving with the Royal Auxiliary Air Force. He now lives with his wife Kaethe near Bexhill in East Sussex.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R W Foster, Norman Franks
      </h2>
      
      <p class="authorDescription body article">Wing Commander R W Foster DFC AE specializes in World War II history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ab92615